(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[995],{

/***/ 1673:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(5318);

var _interopRequireWildcard = __webpack_require__(862);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var React = _interopRequireWildcard(__webpack_require__(7294));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2108));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
  d: "M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z"
}), 'ArrowDownward');

exports.Z = _default;

/***/ }),

/***/ 9594:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(5318);

var _interopRequireWildcard = __webpack_require__(862);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var React = _interopRequireWildcard(__webpack_require__(7294));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2108));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
  d: "M4 12l1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8-8 8z"
}), 'ArrowUpward');

exports.Z = _default;

/***/ }),

/***/ 4566:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(5318);

var _interopRequireWildcard = __webpack_require__(862);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var React = _interopRequireWildcard(__webpack_require__(7294));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2108));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
  d: "M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"
}), 'ExpandMore');

exports.Z = _default;

/***/ }),

/***/ 6434:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/galleries",
      function () {
        return __webpack_require__(6670);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 9275:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ useDisplayIcon; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);

const useDisplayIcon = ()=>{
    const [displayIcon, setDisplayIcon] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        setDisplayIcon(true);
    }, []);
    return displayIcon ? "inline-block" : "none";
};


/***/ }),

/***/ 2491:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ useGalleriesAction; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var _services_nodeApiService__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9885);
/* harmony import */ var _services_utils_removeEmptyFromObject__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3408);
/* harmony import */ var _services_utils_sorts__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7599);
/* harmony import */ var _useInfinitePagination__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6578);





const useGalleriesAction = function(galleriesData) {
    let searchTerm = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    const [galleries, setGalleries] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(galleriesData);
    const _sorts = _services_utils_sorts__WEBPACK_IMPORTED_MODULE_2__/* .sorts.galleries */ .L.galleries;
    const [sort, setSort] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null);
    const [loading, setLoading] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
    const [search, setSearch] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(searchTerm);
    const { loadingMore , setPage , setShouldCall  } = (0,_useInfinitePagination__WEBPACK_IMPORTED_MODULE_3__/* .useInfinitePagination */ .J)((page)=>callApi(page), (response)=>setGalleries({
            ...galleries,
            data: [
                ...galleries.data,
                ...response.data
            ]
        }));
    const callApi = (page)=>{
        const body = (0,_services_utils_removeEmptyFromObject__WEBPACK_IMPORTED_MODULE_4__/* .removeEmptyFromObject */ .h)({
            search,
            page,
            order: sort
        });
        if (Object.keys(body).length !== 0) {
            return _services_nodeApiService__WEBPACK_IMPORTED_MODULE_1__/* ["default"].galleries */ .Z.galleries(body);
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        if (search !== null || sort !== null) {
            setPage(1);
            setLoading(true);
            setShouldCall(true);
            callApi().then((response)=>{
                setGalleries(response.data);
                setLoading(false);
            });
        }
    }, [
        search,
        sort
    ]);
    return {
        galleries,
        setSearch,
        loading,
        loadingMore,
        sort,
        setSort,
        sorts: _sorts
    };
};


/***/ }),

/***/ 6578:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ useInfinitePagination; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);

const useInfinitePagination = (callApi, callback)=>{
    const [page, setPage] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(1);
    const [loadingMore, setLoadingMore] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
    const [shouldCall, setShouldCall] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(true);
    const [calling, setCalling] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
    const trackScrolling = ()=>{
        const footerEstimate = 350;
        if (window.innerHeight + window.scrollY + footerEstimate >= document.body.offsetHeight && shouldCall && !calling) {
            setLoadingMore(true);
            setCalling(true);
            callApi(page + 1).then((response)=>{
                var _response_data_artworks;
                setShouldCall(!!response.data.next_page_url || !!((_response_data_artworks = response.data.artworks) === null || _response_data_artworks === void 0 ? void 0 : _response_data_artworks.next_page_url));
                setCalling(false);
                callback(response.data);
                setLoadingMore(false);
                setPage(page + 1);
            });
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        document.addEventListener("scroll", trackScrolling);
        return ()=>{
            document.removeEventListener("scroll", trackScrolling);
        };
    });
    return {
        loadingMore,
        setPage,
        setShouldCall
    };
};


/***/ }),

/***/ 3280:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7294);
/* harmony import */ var _services_utils_imageResizer__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(3992);
/* harmony import */ var _Layout_Image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6627);
/* harmony import */ var _CircleImages_module_css__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8351);
/* harmony import */ var _CircleImages_module_css__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_CircleImages_module_css__WEBPACK_IMPORTED_MODULE_5__);







const CircleImages = (param)=>{
    let { title , subtitle , image , href , to  } = param;
    const initials = title.split(/\s/).reduce((response, word)=>response += word.slice(0, 1), "").toUpperCase().substring(0, 3);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
        href: href,
        as: to,
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_CircleImages_module_css__WEBPACK_IMPORTED_MODULE_5___default()["circle-image-container"]), "margin m0a"),
        children: [
            image ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Layout_Image__WEBPACK_IMPORTED_MODULE_4__/* .Image */ .E, {
                src: (0,_services_utils_imageResizer__WEBPACK_IMPORTED_MODULE_6__/* .imageResizer */ .J)(image, 200, 200),
                width: "150px",
                height: "150px",
                labelHeight: "150px",
                labelWidth: "150px",
                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_CircleImages_module_css__WEBPACK_IMPORTED_MODULE_5___default().circles), "mb-4", "mx-auto"),
                alt: title
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_CircleImages_module_css__WEBPACK_IMPORTED_MODULE_5___default()["gallery-logo"]), "mb-4", "mx-auto"),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: (_CircleImages_module_css__WEBPACK_IMPORTED_MODULE_5___default()["gallery-inicials"]),
                    children: initials
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                className: "text-black text-center mb-2 font-secondary fw-700 fs-16px",
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "text-center color-gray-super-light font-primary fs-13px font-primary",
                children: subtitle
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CircleImages);


/***/ }),

/***/ 1286:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);


const Container = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "container",
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Container);


/***/ }),

/***/ 8434:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ HeadingTitle; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);



const HeadingTitle = (param)=>{
    let { title , children , href , to  } = param;
    const Title = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                href && to && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                    className: "mb-1",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                        href: href,
                        as: to,
                        className: "text-black fw-600 fs-32px fs-mobile-28px lh-36px d-block",
                        style: {
                            marginLeft: "-3px"
                        },
                        children: title
                    })
                }),
                !href && !to && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                    className: "text-black mb-1 fw-600",
                    style: {
                        marginLeft: "-3px"
                    },
                    children: title
                }),
                children && children !== "" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "color-black font-secondary fs-15px fs-mobile-14px pb-lg-1 mb-0",
                    children: children
                })
            ]
        });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Title, {});
};


/***/ }),

/***/ 6470:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ HelmetTitle; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);



const HelmetTitle = (param)=>/*#__PURE__*/ {
    let { title , hide =false  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
            children: "".concat(title).concat(hide ? "" : " | Discover ArtPlacer")
        })
    });
};


/***/ }),

/***/ 6627:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "E": function() { return /* binding */ Image; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(4184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./features/components/Layout/LoadingLabel/LoadingLabel.module.scss
var LoadingLabel_module = __webpack_require__(7129);
var LoadingLabel_module_default = /*#__PURE__*/__webpack_require__.n(LoadingLabel_module);
;// CONCATENATED MODULE: ./features/components/Layout/LoadingLabel/index.js




const LoadingLabel = (param)=>/*#__PURE__*/ {
    let { height , width , maxWidth , className  } = param;
    return (0,jsx_runtime.jsx)("span", {
        className: classnames_default()((LoadingLabel_module_default())["loading-label"], className),
        style: {
            height,
            width,
            maxWidth
        }
    });
};
LoadingLabel.defaultProps = {
    height: 16,
    width: "100%",
    className: ""
};

;// CONCATENATED MODULE: ./features/components/Layout/Image/index.js



const Image = (param)=>{
    let { src , labelHeight ="250px" , labelWidth ="100%" , ...rest } = param;
    const [loaded, setLoaded] = (0,react.useState)(false);
    const img = (0,react.useRef)();
    (0,react.useEffect)(()=>{
        if (img.current.complete) {
            setLoaded(true);
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            !loaded && /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingLabel, {
                className: rest.className,
                height: labelHeight,
                width: labelWidth
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: src,
                ref: img,
                alt: rest.alt || "",
                style: {
                    display: loaded ? "block" : "none"
                },
                ...rest,
                onLoad: ()=>setLoaded(true)
            })
        ]
    });
};
766;


/***/ }),

/***/ 9542:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ Loader; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _Loader_module_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1299);
/* harmony import */ var _Loader_module_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_Loader_module_css__WEBPACK_IMPORTED_MODULE_2__);



const Loader = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_Loader_module_css__WEBPACK_IMPORTED_MODULE_2___default().loader)
    });


/***/ }),

/***/ 8984:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "y": function() { return /* binding */ SearchSortHeader; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Row.js
var Row = __webpack_require__(4051);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Col.js
var Col = __webpack_require__(1555);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/ArrowDownward.js
var ArrowDownward = __webpack_require__(1673);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/ArrowUpward.js
var ArrowUpward = __webpack_require__(9594);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/ExpandMore.js
var ExpandMore = __webpack_require__(4566);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(4184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./features/actions/useDefaultSortAction.js

const useDefaultSortAction = (sort, sorts, setSort)=>{
    const [showItems, setShowItems] = (0,react.useState)(false);
    const toShow = sort || sorts[0].title;
    const orientation = sort === "createddesc" || sort === "titledesc" || sort === "namedesc" ? "desc" : "";
    sort = sort || toShow;
    const [sortType, setSortType] = (0,react.useState)(orientation) // ;; => asc | desc
    ;
    const toggleItems = ()=>setShowItems(!showItems);
    const onChangeSortType = ()=>{
        sort = sort.toLowerCase().replace("desc", "");
        const _sortType = sortType === "" ? "desc" : "";
        setSortType(_sortType);
        setSort("".concat(sort).concat(_sortType));
    };
    const sanatize = (str)=>(str.charAt(0).toUpperCase() + str.slice(1)).replace("desc", "");
    const _sorts = sorts.filter((_sort)=>_sort.title !== toShow);
    return {
        showItems,
        setShowItems,
        toggleItems,
        sortType,
        onChangeSortType,
        toShow,
        sanatize,
        _sorts
    };
};

// EXTERNAL MODULE: ./features/actions/useDisplayIcon.js
var useDisplayIcon = __webpack_require__(9275);
// EXTERNAL MODULE: ./features/components/Layout/DefaultSort/DefaultSort.module.scss
var DefaultSort_module = __webpack_require__(1952);
var DefaultSort_module_default = /*#__PURE__*/__webpack_require__.n(DefaultSort_module);
;// CONCATENATED MODULE: ./features/components/Layout/DefaultSort/index.js









const DefaultSort = (param)=>{
    let { sort , sorts , setSort  } = param;
    const { showItems , toggleItems , setShowItems , sortType , onChangeSortType , toShow , sanatize , _sorts  } = useDefaultSortAction(sort, sorts, setSort);
    const display = (0,useDisplayIcon/* useDisplayIcon */.i)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "mt-0 position-relative",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "color-gray-super-light fs-14px mr-2",
                children: "Sort by"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                className: classnames_default()((DefaultSort_module_default()).sorting, "mr-2", "position-relative"),
                onClick: ()=>toggleItems(),
                children: [
                    sanatize(toShow),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandMore/* default */.Z, {
                        style: {
                            verticalAlign: "middle",
                            fontSize: "15px",
                            position: "absolute",
                            top: "8px",
                            right: "4px",
                            display
                        }
                    })
                ]
            }),
            showItems && _sorts.filter((_sort)=>_sort.title !== sanatize(toShow)).map((_sort, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: classnames_default()((DefaultSort_module_default()).sorting, (DefaultSort_module_default())["sorting-item"], "position-absolute"),
                    style: {
                        top: "".concat(35 * (index + 1), "px")
                    },
                    onClick: ()=>{
                        setSort("".concat(_sort.title.toLowerCase()).concat(sortType));
                        setShowItems(false);
                    },
                    children: _sort.title
                }, index)),
            sortType === "" && /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowDownward/* default */.Z, {
                onClick: ()=>{
                    onChangeSortType();
                },
                style: {
                    fontSize: "16px",
                    display
                }
            }),
            sortType === "desc" && /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowUpward/* default */.Z, {
                onClick: ()=>{
                    onChangeSortType();
                },
                style: {
                    fontSize: "16px",
                    display
                }
            })
        ]
    });
};
/* harmony default export */ var Layout_DefaultSort = (DefaultSort);

// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Search.js
var Search = __webpack_require__(8995);
// EXTERNAL MODULE: ./features/components/Layout/SearchInput/SearchInput.module.scss
var SearchInput_module = __webpack_require__(10);
var SearchInput_module_default = /*#__PURE__*/__webpack_require__.n(SearchInput_module);
;// CONCATENATED MODULE: ./features/components/Layout/SearchInput/index.js






const SearchInput = (param)=>{
    let { onChange , searchPlaceholder  } = param;
    const [query, setQuery] = (0,react.useState)("");
    const display = (0,useDisplayIcon/* useDisplayIcon */.i)();
    const onUpdateInput = ()=>onChange(query);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "position-relative",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                className: classnames_default()("form-control form-control-sm mr-3 w-100 d-flex justify-content-center", (SearchInput_module_default()).input),
                type: "text",
                placeholder: searchPlaceholder,
                "aria-label": searchPlaceholder,
                onChange: (e)=>setQuery(e.target.value),
                onKeyPress: (event)=>{
                    if (event.key === "Enter") onUpdateInput();
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Search/* default */.Z, {
                className: classnames_default()((SearchInput_module_default())["search-icon"], "cursor-pointer"),
                style: {
                    display
                },
                onClick: onUpdateInput
            })
        ]
    });
};

;// CONCATENATED MODULE: ./features/components/Layout/SearchSortHeader/index.js





const SearchSortHeader = (param)=>{
    let { title , onChangeInput , hideSearch =true , searchPlaceholder ="Filter galleries" , children , sort , sorts , setSort  } = param;
    const cols = hideSearch ? 6 : 4;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
        className: "align-items-center mb-4 justify-content-between".concat(!title && hideSearch ? " flex-row-reverse" : ""),
        children: [
            title && /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                xs: hideSearch ? 5 : 12,
                sm: hideSearch ? 5 : 12,
                md: cols,
                className: "".concat(hideSearch ? "" : "pb-3", " pb-md-0"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "fs-13px color-gray-super-light font-weight-normal",
                    children: title
                })
            }),
            !hideSearch && /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                xs: 12,
                md: cols,
                className: "mb-md-0 mb-sm-4 mb-xs-4 mt-sm-3",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchInput, {
                    searchPlaceholder: searchPlaceholder,
                    onChange: onChangeInput
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                xs: hideSearch ? 7 : 12,
                sm: hideSearch ? 7 : 12,
                md: cols,
                className: "text-right",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout_DefaultSort, {
                    sort: sort,
                    sorts: sorts,
                    setSort: setSort
                })
            }),
            children && /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                xs: !title ? 5 : 12,
                children: children
            })
        ]
    });
};


/***/ }),

/***/ 7182:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ SeoTags; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);



const SeoTags = (param)=>{
    let { description , title , image ="https://artplacer-nextjs.herokuapp.com/artplacer-logo.png" , url , canonical  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                httpEquiv: "X-UA-Compatible",
                content: "IE=edge,chrome=1"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:card",
                content: "summary"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:site",
                content: "ArtPlacer"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:title",
                content: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:image",
                content: image
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:site_name",
                content: "ArtPlacer"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:type",
                content: "website"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:url",
                content: url
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: image
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: description
            }),
            canonical && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "canonical",
                href: canonical
            })
        ]
    });
};


/***/ }),

/***/ 1350:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _providers_AppProvider__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2674);



const Wrapper = (param)=>{
    let { children  } = param;
    const { profile  } = (0,_providers_AppProvider__WEBPACK_IMPORTED_MODULE_2__/* .useAppContext */ .b)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "content-wrap".concat(profile.embedded ? " embedded" : ""),
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Wrapper);


/***/ }),

/***/ 6670:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ galleries; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Row.js
var Row = __webpack_require__(4051);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Col.js
var Col = __webpack_require__(1555);
// EXTERNAL MODULE: ./services/utils/linksBuilder.js
var linksBuilder = __webpack_require__(3372);
// EXTERNAL MODULE: ./features/actions/useGalleriesAction.js
var useGalleriesAction = __webpack_require__(2491);
// EXTERNAL MODULE: ./features/components/CirclesImages/index.js
var CirclesImages = __webpack_require__(3280);
// EXTERNAL MODULE: ./features/components/Layout/Container/index.js
var Container = __webpack_require__(1286);
// EXTERNAL MODULE: ./features/components/Layout/HeadingTitle/index.js
var HeadingTitle = __webpack_require__(8434);
// EXTERNAL MODULE: ./features/components/Layout/HelmetTitle/index.js
var HelmetTitle = __webpack_require__(6470);
// EXTERNAL MODULE: ./features/components/Layout/Loader/index.js
var Loader = __webpack_require__(9542);
// EXTERNAL MODULE: ./features/components/Layout/SearchSortHeader/index.js + 3 modules
var SearchSortHeader = __webpack_require__(8984);
// EXTERNAL MODULE: ./features/components/Layout/Wrapper/index.js
var Wrapper = __webpack_require__(1350);
// EXTERNAL MODULE: ./features/components/Layout/SeoTags/index.js
var SeoTags = __webpack_require__(7182);
;// CONCATENATED MODULE: ./features/pages/GalleriesPage/index.js













const GalleriesPage = (param)=>{
    let { galleries: galleriesData  } = param;
    const { galleries , setSearch , loading , loadingMore , setSort , sorts , sort  } = (0,useGalleriesAction/* useGalleriesAction */.E)(galleriesData);
    if (!galleries) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SeoTags/* SeoTags */.o, {
                title: "Galleries | Discover ArtPlacer",
                description: "Explore our partner art galleries and artists.",
                url: "https://discover.artplacer.com/galleries",
                canonical: "https://discover.artplacer.com/galleries"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HelmetTitle/* HelmetTitle */.i, {
                title: "Galleries"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeadingTitle/* HeadingTitle */.E, {
                        title: "Galleries",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "font-primary",
                                children: "Explore our Partner Galleries and Artists."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "color-black",
                                children: [
                                    "If you'd like to become a Partner Gallery,",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: "fw-700",
                                        href: "https://www.artplacer.com/signup/",
                                        target: "_blank",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("u", {
                                            children: "join our community."
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchSortHeader/* SearchSortHeader */.y, {
                        title: "",
                        onChangeInput: (val)=>setSearch(val),
                        sorts: sorts,
                        sort: sort !== null && sort !== void 0 ? sort : "createddesc",
                        setSort: setSort,
                        hideSearch: false
                    }),
                    loading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* Loader */.a, {}),
                    !loading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                        children: galleries.data.map((gallery)=>{
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                xl: 2,
                                lg: 3,
                                md: 4,
                                sm: 6,
                                xs: 12,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CirclesImages/* default */.Z, {
                                    title: gallery.name,
                                    subtitle: gallery.address,
                                    image: gallery.thumbnail,
                                    to: linksBuilder/* linksBuilder.galleries */.m.galleries(gallery.domain),
                                    href: "/galleries/[id]"
                                })
                            }, "galleries-".concat(gallery.id));
                        })
                    }),
                    loadingMore && /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* Loader */.a, {})
                ]
            })
        ]
    });
};
/* harmony default export */ var pages_GalleriesPage = (GalleriesPage);

;// CONCATENATED MODULE: ./pages/galleries/index.js



const Galleries = (param)=>/*#__PURE__*/ {
    let { galleries  } = param;
    return (0,jsx_runtime.jsx)(pages_GalleriesPage, {
        galleries: galleries
    });
};
var __N_SSP = true;
/* harmony default export */ var galleries = (Galleries);


/***/ }),

/***/ 9885:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ services_nodeApiService; }
});

// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
;// CONCATENATED MODULE: ./config/axiosNodeClient.js

const client = axios_default().create({
    baseURL: "https://discover.artplacer.com/api/"
});
client.interceptors.request.use((request)=>{
    console.log("Starting Request", "".concat(request.baseURL).concat(request.url));
    return request;
});
const axiosNodeClient = client;

;// CONCATENATED MODULE: ./services/nodeApiService.js

const nodeApiService = ()=>({
        artworks: (params)=>{
            return axiosNodeClient.get("artworks", {
                params
            });
        },
        galleryArtworks: (id, params)=>{
            return axiosNodeClient.get("galleries/".concat(id, "/artworks"), {
                params
            });
        },
        galleryArtworksByCollection: function(id, collection_slug) {
            let params = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
            return axiosNodeClient.get("galleries/".concat(id, "/collections/").concat(encodeURIComponent(collection_slug)), {
                params
            });
        },
        gallery: (id)=>axiosNodeClient.get("galleries/".concat(id)),
        galleries: (params)=>{
            return axiosNodeClient.get("galleries", {
                params
            });
        },
        search: (params)=>{
            return axiosNodeClient.get("search", {
                params
            });
        },
        spaces: (params)=>{
            return axiosNodeClient.get("spaces", {
                params
            });
        },
        contact: (body)=>{
            return axiosNodeClient.post("contact", body);
        },
        dataCapture: (galleryId, body)=>{
            return axiosNodeClient.post("galleries/".concat(galleryId, "/datacapture"), body);
        },
        contactGallery: (galleryId, body)=>{
            return axiosNodeClient.post("galleries/".concat(galleryId, "/contact"), body);
        },
        inquire: (artworkId, body)=>{
            return axiosNodeClient.post("artworks/".concat(artworkId, "/inquire"), body);
        },
        purchase: (artworkId, body)=>{
            return axiosNodeClient.post("artworks/".concat(artworkId, "/purchase"), body);
        },
        exhibitions: (params)=>{
            return axiosNodeClient.get("exhibitions", {
                params
            });
        }
    });
/* harmony default export */ var services_nodeApiService = (nodeApiService());


/***/ }),

/***/ 3992:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ imageResizer; }
/* harmony export */ });
const imageResizer = (image, width, height)=>{
    if (!image) {
        return null;
    }
    if (!image.includes("cloudfront.net")) {
        return image;
    }
    const splittedImage = image.split("/");
    splittedImage.splice(splittedImage.length - 1, 0, "".concat(width, "x").concat(height));
    return splittedImage.join("/");
};


/***/ }),

/***/ 3372:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ linksBuilder; }
/* harmony export */ });
/* harmony import */ var _slugify__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3384);

const linksBuilder = {
    artworks: (domain, id, str)=>domain ? "/galleries/".concat(domain, "/artworks/").concat(id, "-").concat((0,_slugify__WEBPACK_IMPORTED_MODULE_0__/* .slugify */ .l)(str)) : "/artworks/".concat(id, "-").concat((0,_slugify__WEBPACK_IMPORTED_MODULE_0__/* .slugify */ .l)(str)),
    galleries: (str)=>"/galleries/".concat(str),
    collections: (id, collection)=>"/galleries/".concat(id, "/collections/").concat((0,_slugify__WEBPACK_IMPORTED_MODULE_0__/* .slugifyCollection */ .b)(collection))
};


/***/ }),

/***/ 3408:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ removeEmptyFromObject; }
/* harmony export */ });
const removeEmptyFromObject = (obj)=>obj && Object.keys(obj).filter((k)=>obj[k] != null).reduce((newObj, k)=>typeof obj[k] === "object" ? {
            ...newObj,
            [k]: removeEmptyFromObject(obj[k])
        } : {
            ...newObj,
            [k]: obj[k]
        }, {});


/***/ }),

/***/ 3384:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ slugifyCollection; },
/* harmony export */   "l": function() { return /* binding */ slugify; }
/* harmony export */ });
const slugify = (str)=>str.toLowerCase().replace(/ /g, "-").replace(/[^\w-]+/g, "");
const slugifyCollection = (str)=>encodeURIComponent(str.toLowerCase());


/***/ }),

/***/ 7599:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ sorts; }
/* harmony export */ });
const sorts = {
    galleries: [
        {
            title: "Created",
            sort: "created"
        },
        {
            title: "Name",
            sort: "name"
        }
    ],
    artworks: [
        {
            title: "Title",
            sort: "title"
        },
        {
            title: "Created",
            sort: "created"
        }
    ],
    spaces: [
        {
            title: "Title",
            sort: "title"
        },
        {
            title: "Created",
            sort: "created"
        }
    ],
    exhibitions: [
        {
            title: "Created",
            sort: "created"
        },
        {
            title: "Title",
            sort: "title"
        }
    ]
};


/***/ }),

/***/ 8351:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"circle-image-container":"CircleImages_circle-image-container__3OhLu","circles":"CircleImages_circles__kYojl","gallery-logo":"CircleImages_gallery-logo__7PsMY","gallery-inicials":"CircleImages_gallery-inicials__MpC3t"};

/***/ }),

/***/ 1299:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loader_loader__XMXzR","spin":"Loader_spin__Gfb8_"};

/***/ }),

/***/ 1952:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sorting":"DefaultSort_sorting__8t63O","sorting-item":"DefaultSort_sorting-item__JONvf"};

/***/ }),

/***/ 7129:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"loading-label":"LoadingLabel_loading-label__Mwpie","loadingBackgroundAnimation":"LoadingLabel_loadingBackgroundAnimation__bAvDv"};

/***/ }),

/***/ 10:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"input":"SearchInput_input__nJY8g","search-icon":"SearchInput_search-icon__FrISA"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [144,774,888,179], function() { return __webpack_exec__(6434); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);